
import Vue from "vue";
import OrganisationEditor from "@/components/OrganisationEditor.vue";
import { Confirmation } from "@/util/helpers";
import { useAdmin, useAuth, useLayout } from "@/services";
import { mapState } from "pinia";

export default Vue.extend({
  name: "Organisations",
  components: {
    OrganisationEditor,
  },
  data: () => ({
    isRsPristine: true,
    selectedOrg: "",
    newOrgName: "",
    sidebarOrgSettingsList: [] as string[], // For viewing in sidebar, contains added orgs
  }),
  computed: {
    ...mapState(useAdmin, ["organisationsList", "organisation"]),
    isNewOrgSetting(): boolean {
      return !(
        !this.selectedOrg || this.organisationsList.includes(this.selectedOrg)
      );
    },
  },
  mounted() {
    if (useAuth().isLoggedIn) {
      useLayout().isRightSidebarOpen = true;
    }
    useAdmin()
      .listOrganisations()
      .then(() => {
        this.sidebarOrgSettingsList = [...useAdmin().organisationsList];
        this.selectOrganisation(this.organisationsList[0]);
      });
  },
  methods: {
    isSelectedOrg(org: string) {
      return this.selectedOrg && this.selectedOrg === org;
    },
    selectOrganisation(org: string): void {
      this.selectedOrg = org;

      if (!this.isNewOrgSetting) {
        useAdmin().getOrganisation(org);
      }
    },
    createOrgSetting(): void {
      // create empty orgsettings file, add to organisation list, select it
      this.sidebarOrgSettingsList.push(this.newOrgName);
      this.selectedOrg = this.newOrgName;
      this.newOrgName = "";
      useAdmin().getOrganisation("template");
    },
    deleteOrgSetting(organisationId: string) {
      if (!this.isNewOrgSetting) {
        Confirmation.fire({
          icon: "error",
          iconHtml: "!",
          html: "Delete <strong>" + organisationId + "</strong>?",
          confirmButtonText: "Delete Organisation Setting",
          confirmButtonAriaLabel: "Confirm Settings Deletion",
          cancelButtonAriaLabel: "Cancel Settings Deletion",
          customClass: {
            confirmButton: "btn btn-danger",
            cancelButton: "btn btn-outline-info mr-3",
          },
          focusConfirm: false,
          focusCancel: true,
        }).then((r) => {
          if (r.isConfirmed) {
            // Call API when org setting is currently stored on S3
            useAdmin()
              .deleteOrganisation(organisationId)
              .then(() =>
                this.makeToast(
                  "success",
                  `Successfully deleted ${organisationId}`,
                  "Request completed"
                )
              )
              .catch(() =>
                this.makeToast(
                  "danger",
                  `Failed to delete ${organisationId}`,
                  "Request failed"
                )
              );

            useAdmin().organisation = null;
            useAdmin().listOrganisations();
          }
        });
      } else {
        this.sidebarOrgSettingsList = this.sidebarOrgSettingsList.filter(
          (f: string) => f !== organisationId
        );
        useAdmin().organisation = null;
        this.selectedOrg = "";
      }
    },
    makeToast(variant: string, message: string, content: string) {
      this.$bvToast.toast(content, {
        title: message,
        variant: variant,
        solid: true,
      });
    },
  },
});
